var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinth3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "960px",
    height: "869px",
    viewBox: "0 0 960 869",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "linth3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "linth3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "linth3-copy",
    transform: "translate(-0.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FB6340",
    points: "180.9 240.6 59.7 240.6 120.3 180"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2DCE89",
    points: "0.3 240.6 0.3 0.6 240.3 0.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F4F5F7",
    points: "240.3 240.6 0.3 0.6 240.3 0.6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4F5F7",
    cx: 840.25,
    cy: 361.09,
    r: 100.84
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.000000, 0.300000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M843.77,240.229998 C874.667721,240.224695 904.302059,252.49368 926.153798,274.337917 C948.005537,296.182155 960.284696,325.812279 960.29,356.71 L960.29,360.210002 L956.79,360.210002 C925.890546,360.215305 896.254693,347.944947 874.402666,326.098547 C852.55064,304.252147 840.272652,274.619454 840.27,243.72 L840.27,240.229998 L843.77,240.229998 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.789998,360.25 L720.289998,360.25 L720.289998,356.75 C720.284695,325.852279 732.55368,296.217941 754.397917,274.366202 C776.242155,252.514463 805.872279,240.235304 836.77,240.23 L840.270004,240.23 L840.270004,243.72 C840.277957,274.619454 828.010144,304.256361 806.165619,326.110263 C784.321094,347.964165 754.689454,360.244696 723.789998,360.25 L723.789998,360.25 Z",
    id: "Path",
    fill: "#2DCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.79,360.23 L840.290002,360.23 L840.290002,363.72 C840.295305,394.620373 828.025267,424.257255 806.179154,446.110869 C784.333041,467.964484 754.700373,480.244696 723.8,480.25 L720.309998,480.25 L720.309998,476.75 C720.304695,445.852279 732.57368,416.217941 754.417917,394.366202 C776.262155,372.514463 805.892279,360.235304 836.79,360.23 L836.79,360.23 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.81,480.210002 C925.910546,480.215305 896.274693,467.944947 874.422666,446.098547 C852.57064,424.252147 840.292652,394.619454 840.29,363.72 L840.29,360.229998 L843.79,360.229998 C874.687721,360.224695 904.322059,372.49368 926.173798,394.337917 C948.025537,416.182155 960.304696,445.812279 960.31,476.71 L960.31,480.210002 L956.81,480.210002 Z",
    id: "Path",
    fill: "#2DCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,240.57 L240,240.57 L240,360.57 C240,426.84417 186.27417,480.57 120,480.57 L-2.27373675e-13,480.57 L-2.27373675e-13,360.57 C-2.27373675e-13,294.29583 53.72583,240.57 120,240.57 Z",
    id: "Path",
    fill: "#2DCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,292.46 C158.963689,292.46 190.55,324.046311 190.55,363.01 C190.55,401.973689 158.963689,433.56 120,433.56 L49.45,433.56 L49.45,363.01 C49.45,324.046311 81.0363109,292.46 120,292.46 L120,292.46 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.6,240.57 L240.6,240.57 L240.6,288.57 C240.6,328.334502 208.364502,360.57 168.6,360.57 L120.6,360.57 L120.6,312.57 C120.6,272.805498 152.835498,240.57 192.6,240.57 L192.6,240.57 Z",
    id: "Path",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.24,481.01 L72.77,481.01 C72.77,521.067213 40.2972129,553.54 0.24,553.54 L0.24,481.01 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,240.57 C295.84583,240.57 242.12,294.29583 242.12,360.57 C242.12,426.84417 295.84583,480.57 362.12,480.57 L482.12,480.57 L482.12,360.57 C482.12,294.29583 428.39417,240.57 362.12,240.57 Z",
    id: "Path",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.36,337.08 C370.728046,337.08 338.6,369.208046 338.6,408.84 C338.6,448.471954 370.728046,480.6 410.36,480.6 L482.12,480.6 L482.12,408.84 C482.12,389.808065 474.559593,371.555628 461.101983,358.098017 C447.644372,344.640407 429.391935,337.08 410.36,337.08 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,286.129999 C332.483232,286.125955 305.762629,303.976135 294.419261,331.356165 C283.075892,358.736195 289.343927,390.253353 310.300287,411.209713 C331.256647,432.166073 362.773805,438.434108 390.153835,427.090739 C417.533865,415.747371 435.384045,389.026768 435.380001,359.39 C435.380001,318.929619 402.580381,286.129999 362.12,286.129999 L362.12,286.129999 Z",
    id: "Path",
    fill: "#2DCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.12,316.5 C338.432507,316.5 319.23,335.702507 319.23,359.39 C319.23,383.077493 338.432507,402.28 362.12,402.28 C385.807493,402.28 405.01,383.077493 405.01,359.39 C405.01,335.702507 385.807493,316.5 362.12,316.5 L362.12,316.5 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.14,120.57 L720.14,239.97 L600.75,239.97 C534.138936,239.97 480.14,185.971064 480.14,119.36 L480.14,2.27373675e-13 L599.54,2.27373675e-13 C666.136113,-0.0055234396 720.128955,53.9738873 720.14,120.57 L720.14,120.57 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.280001,120 C668.280001,145.205088 654.833248,168.495551 633.005001,181.098096 C611.176755,193.70064 584.283245,193.70064 562.454999,181.098096 C540.626752,168.495551 527.18,145.205088 527.18,120 L527.18,49.44 L597.73,49.44 C616.442756,49.44 634.38894,56.8742976 647.619919,70.107152 C660.850898,83.3400064 668.282652,101.287244 668.280001,120 L668.280001,120 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M720.14,192.57 L720.14,240.57 L672.14,240.57 C632.375498,240.57 600.14,208.334502 600.14,168.57 L600.14,120.57 L648.14,120.57 C687.904502,120.57 720.14,152.805498 720.14,192.57 L720.14,192.57 Z",
    id: "Path",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.08,479.01 C667.078028,479.01 720.58,425.508028 720.58,359.51 C720.58,293.511972 667.078028,240.01 601.08,240.01 L481.58,240.01 L481.58,359.51 C481.58,425.508028 535.081972,479.01 601.08,479.01 Z",
    id: "Path",
    fill: "#F4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.82,374.533333 C585.955627,374.533333 616.06,344.42896 616.06,307.293333 C616.06,270.157707 585.955627,240.053333 548.82,240.053333 L481.58,240.053333 L481.58,307.293333 C481.58,325.12649 488.664194,342.229247 501.27414,354.839193 C513.884086,367.449139 530.986843,374.533333 548.82,374.533333 L548.82,374.533333 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.080153,429.685834 C628.938745,429.685834 654.054024,412.903721 664.714167,387.165374 C675.37431,361.427028 669.47985,331.8015 649.779506,312.103846 C630.079163,292.406191 600.452831,286.515775 574.71594,297.179431 C548.979049,307.843087 532.200364,332.960656 532.204166,360.819247 C532.204166,379.08543 539.461023,396.603341 552.378046,409.518601 C565.29507,422.433862 582.81397,429.688327 601.080153,429.685834 Z",
    id: "Path",
    fill: "#2DCE89"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.08,396.785 C620.942461,396.785 637.044166,380.683294 637.044166,360.820833 C637.044166,340.958372 620.942461,324.856667 601.08,324.856667 C581.217539,324.856667 565.115833,340.958372 565.115833,360.820833 C565.115833,380.683294 581.217539,396.785 601.08,396.785 L601.08,396.785 Z",
    id: "Path",
    fill: "#172B4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.45,576.68 C207.45,609.2648 233.8652,635.68 266.45,635.68 C299.0348,635.68 325.45,609.2648 325.45,576.68 C325.45,544.0952 299.0348,517.68 266.45,517.68 C233.8652,517.68 207.45,544.0952 207.45,576.68 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.86,453.57 C207.86,471.911377 222.728623,486.78 241.07,486.78 C259.411377,486.78 274.28,471.911377 274.28,453.57 C274.28,435.228623 259.411377,420.36 241.07,420.36 C222.728623,420.36 207.86,435.228623 207.86,453.57 Z",
    id: "Path",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.27,521.57 C780.27,554.1548 806.6852,580.57 839.27,580.57 C871.8548,580.57 898.27,554.1548 898.27,521.57 C898.27,488.9852 871.8548,462.57 839.27,462.57 C806.6852,462.57 780.27,488.9852 780.27,521.57 L780.27,521.57 Z",
    id: "Path",
    fill: "#FB6340"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.597962,620.450843 L161.397962,586.740843 C181.71328,573.103339 191.801955,548.562637 186.952331,524.579834 C182.102708,500.597032 163.271682,481.904255 139.253796,477.231481 C115.235911,472.558707 90.7702126,482.827937 77.2827732,503.243192 C63.7953338,523.658446 63.9474035,550.191526 77.6679622,570.450843 L111.597962,620.450843 Z",
    id: "Path",
    fill: "#2DCE89",
    transform: "translate(127.712736, 548.283642) rotate(-51.000000) translate(-127.712736, -548.283642) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.479998,640.57 C482.479998,658.911377 497.348623,673.78 515.69,673.78 C534.031377,673.78 548.9,658.911377 548.9,640.57 C548.9,622.228623 534.031377,607.359998 515.69,607.359998 C506.881347,607.357346 498.432712,610.855395 492.204053,617.084053 C485.975395,623.312712 482.477346,631.761347 482.479998,640.57 L482.479998,640.57 Z",
    id: "Path",
    fill: "#FB6340"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F5365C",
    cx: 360.52,
    cy: 120,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#172B4D",
    cx: 359.12,
    cy: 120.6,
    r: 70.45
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#2DCE89",
    cx: 359.12,
    cy: 120.6,
    r: 37.01
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FB6340",
    cx: 839.92,
    cy: 120.9,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#172B4D",
    cx: 840.52,
    cy: 120.3,
    r: 70.45
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F4F5F7",
    cx: 840.52,
    cy: 120.3,
    r: 37.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.74,667.43 C688.74,733.43 635.41,786.84 569.62,786.84 C569.66,720.87 622.95,667.43 688.74,667.43 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.699456,543.774129 L581.319456,546.844129 L578.259456,548.464129 C521.809456,578.354129 451.769456,556.704129 421.809456,500.124129 L420.179456,497.044129 L423.249456,495.424129 C479.689456,465.534129 549.739456,487.234129 579.699456,543.774129 L579.699456,543.774129 Z",
    id: "Path",
    fill: "#2DCE89",
    transform: "translate(500.749456, 521.949116) rotate(-50.000000) translate(-500.749456, -521.949116) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.66,479.28 L573.16,476.15 L576.3,477.65 C634.04,505.33 658.46,574.45 630.85,632.05 L629.35,635.18 L626.22,633.67 C568.44,606 544.02,536.87 571.66,479.28 Z",
    id: "Path",
    fill: "#F5365C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.74,782.96 L807.74,786.43 L804.27,786.43 C740.4,786.43 688.62,734.53 688.62,670.5 L688.62,667.02 L692.09,667.02 C755.96,667.02 807.74,718.93 807.74,782.96 Z",
    id: "Path",
    fill: "#2DCE89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinth3);
export default __webpack_public_path__ + "static/media/linth3.41699b02d6016e3f145071391f43d55d.svg";
export { ForwardRef as ReactComponent };